import {
  Component,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { RRITag } from '../../interfaces/tag.interface';

@Component({
  selector: 'rr-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent<T extends RRITag> implements OnChanges {
  public tagsToDisplay: T[];
  private _iterableDiffer: IterableDiffer<unknown>;

  @Input() tags: T[];
  @Input() maxAmount: number;
  @Input() showRemoveButton: boolean;
  @Input() hasClickAction: boolean;
  @Output() tagClicked: EventEmitter<T> = new EventEmitter<T>();
  @Output() removeClicked: EventEmitter<T> = new EventEmitter<T>();

  constructor(private _iterableDiffers: IterableDiffers) {
    this._iterableDiffer = this._iterableDiffers.find([]).create(null);
  }

  //TODO
  // eslint-disable-next-line @angular-eslint/no-conflicting-lifecycle
  ngOnChanges(changes: SimpleChanges): void {
    const maxAmount = changes['maxAmount'];
    const tags = changes['tags'];
    if (
      maxAmount &&
      maxAmount.currentValue &&
      tags &&
      tags.currentValue &&
      tags.currentValue.length > maxAmount.currentValue
    ) {
      this.splitTags(tags.currentValue, maxAmount.currentValue);
    } else {
      this.tagsToDisplay = this.tags;
    }
  }

  //TODO
  // eslint-disable-next-line @angular-eslint/no-conflicting-lifecycle, @angular-eslint/use-lifecycle-interface
  ngDoCheck(): void {
    const tagsChanged = this._iterableDiffer.diff(this.tags);
    if (tagsChanged) {
      if (this.maxAmount && this.tags.length > this.maxAmount) {
        this.splitTags(this.tags, this.maxAmount);
      }
    }
  }

  public onRemoveTagClicked(tag: T): void {
    this.removeClicked.emit(tag);
  }

  public onTagClicked(tag: T): void {
    this.tagClicked.emit(tag);
  }

  private splitTags(tags: T[], maxAmount: number): void {
    const tempTags = tags.slice(0, maxAmount);
    const otherTags = tags.slice(maxAmount, tags.length);

    this.tagsToDisplay = tempTags.concat([
      {
        name: `+${this.tags.length - this.maxAmount}`,
        description: otherTags.map((o: T) => o.name).join(', '),
        color: '#000',
      } as T,
    ]);
  }
}
